import React, { useEffect } from "react";
import "./index.scss";

const Modal = ({
  isOpen,
  width,
  height,
  onClose,
  title,
  entityID,
  filledBy,
  children,
  size = "large",
  headerAction,
}) => {
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "unset";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay"
      //     className={`
      //   bg-white modal-overlay
      //   ${
      //     size === "fullscreen"
      //       ? "w-screen h-screen max-w-none rounded-none m-0"
      //       : "max-w-4xl rounded-xl"
      //   }
      // `}
    >
      <div
        className={`modal-container modal-${size}`}
        style={{
          width: width || undefined,
          height: height || undefined,
          maxWidth: width || undefined,
          maxHeight: height || undefined,
        }}
      >
        <div className="modal-header">
          <div>
            <h2>
              {title}
              {entityID ? ` — ${entityID}` : ""}
            </h2>
            {filledBy && (
              <div className="modal-header__filled-by">
                Filled By: <span>{filledBy}</span>
              </div>
            )}
          </div>
          {headerAction ?? (
            <button className="modal-close" onClick={onClose}>
              &times;
            </button>
          )}
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
